<template>
  <div class="login-firstTime">
    <div id="page-content-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-7 loginLeft">
            <img src="assets/images/login-graphic.png" alt="" />
          </div>

          <div class="col-md-5 loginRight">
            <div class="loginWrapper">
              <div class="loginText">
                <h2>
                  Please, confirm reset your password:
                </h2>
                <p class="registeredPhone">Enter your card number:</p>
              </div>

              <div class="loginControls regNo">
                <form action="form" @submit.prevent="sendResetPasswordSmsCode">
                  <input
                    id="ccn"
                    type="tel"
                    inputmode="numeric"
                    autocomplete="cc-number"
                    maxlength="9"
                    placeholder="9 Digit number on your card"
                    v-model.number="cardNumber"
                  />
                  <button
                    v-if="
                      isPostCardNumberToSendResetPasswordSmsCodeButtonLoading ===
                        true
                    "
                    type="submit"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending...
                  </button>
                  <button
                    v-if="
                      isPostCardNumberToSendResetPasswordSmsCodeButtonLoading ===
                        false
                    "
                    type="submit"
                  >
                    Send
                  </button>
                  <router-link v-bind:to="loginRoute" class="backToLogin"
                    >Back to login page</router-link
                  >
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import routes from "@/constants/routes";
import actions from "@/store/accounts/actions";

export default {
  created() {
    this.loginRoute = routes.LOGIN;
  },
  data: () => ({
    cardNumber: null
  }),
  computed: {
    isPostCardNumberToSendResetPasswordSmsCodeButtonLoading: {
      get() {
        return this.$store.state.settings
          .isPostCardNumberToSendResetPasswordSmsCodeButtonLoading;
      },
      set(value) {
        this.$store.commit(
          "updateIsPostCardNumberToSendResetPasswordSmsCodeButtonLoadingMutation",
          value
        );
      }
    }
  },
  methods: {
    sendResetPasswordSmsCode: async function() {
      this.isPostCardNumberToSendResetPasswordSmsCodeButtonLoading = true;
      const formedPayload = {
        cardNumber: this.cardNumber
      };

      await this.$store.dispatch(
        actions.POST_CARD_NUMBER_TO_RESET_PASSWORD_SEND_SMS,
        formedPayload
      );
    }
  }
};
</script>
